module.exports = function() {
  return new Worker(__webpack_public_path__ + "d30e80a7560b76e6abff.worker.js");
};